"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js"),t=require("react/jsx-runtime"),l=require("styled-components"),i=require("@vds/modals"),s=require("@vds/typography"),a=require("@vds-tokens/core");function d(e){return e&&e.__esModule?e:{default:e}}var o=d(l);const n=o.default.ul.withConfig({displayName:"List",componentId:"VDS__sc-1v9bvkb-0"})`
  list-style-type: none;
  margin: 0px;
  padding: 0px;

  li:first-child {
    div:first-child {
      padding-top: ${a.LayoutTokens.space["2X"].value};
    }
  }

  li:last-child {
    div:last-child {
      padding: 0px;
    }
  }
`,r=o.default.li.withConfig({displayName:"ListItem",componentId:"VDS__sc-1v9bvkb-1"})`
  display: flex;
  flex-direction: column;
  width: 100%;
`,u=o.default.div.withConfig({displayName:"TitleWrapper",componentId:"VDS__sc-1v9bvkb-2"})`
  display: flex;
  padding-bottom: ${a.LayoutTokens.space["2X"].value};
`,c=o.default.div.withConfig({displayName:"BodyWrapper",componentId:"VDS__sc-1v9bvkb-3"})`
  display: flex;
  padding-bottom: ${a.LayoutTokens.space["6X"].value};
`;exports.default=l=>{const{title:d,subtitle:o,list:p,surface:v="dark",buttonData:b}=l,m=e.__rest(l,["title","subtitle","list","surface","buttonData"]),y="dark"===v?a.ColorTokens.elements.primary.ondark.value:a.ColorTokens.elements.primary.onlight.value;return t.jsxs(i.Modal,Object.assign({surface:v},m,{children:[t.jsx(i.ModalTitle,Object.assign({},d)),t.jsxs(i.ModalBody,{children:[o&&(null==o?void 0:o.children)&&(null==o?void 0:o.children),p&&p.data&&t.jsx(n,{children:null===(f=null==p?void 0:p.data)||void 0===f?void 0:f.map(((e,l)=>t.jsxs(r,{children:[t.jsx(u,{children:t.jsx(s.Title,Object.assign({size:"small",color:y,bold:!0},null==e?void 0:e.title))}),t.jsx(c,{children:t.jsx(s.Body,Object.assign({size:"large",color:y},null==e?void 0:e.body))})]},l)))})]}),t.jsx(i.ModalFooter,{buttonData:b})]}));var f};
